export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'NV_Sklad';
export const NAME = 'SkladNovychVozu';
